var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.modal_id,
            title: "納品",
            size: "xl",
            "header-bg-variant": "dark",
            "header-text-variant": "light",
            "body-bg-variant": "light",
            "hide-footer": "",
            centered: "",
            scrollable: "",
          },
          on: { hide: _vm.closeModal },
        },
        [
          _c(
            "form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.updateNouhin.apply(null, arguments)
                },
              },
            },
            [
              _vm.errors.length != 0
                ? _c(
                    "div",
                    _vm._l(_vm.errors, function (e) {
                      return _c("ul", { key: e }, [
                        _c(
                          "li",
                          [
                            _c("font", { attrs: { color: "red" } }, [
                              _vm._v(_vm._s(e)),
                            ]),
                          ],
                          1
                        ),
                      ])
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-inline",
                  staticStyle: { margin: "10px 0px" },
                },
                [
                  _c("label", [_vm._v("伝票番号")]),
                  _vm._v(" "),
                  _c(
                    "b-form-select",
                    {
                      style: _vm.mitumori.cancel
                        ? "text-decoration: line-through; width: 200px;"
                        : "width: 200px;",
                      attrs: { disabled: _vm.mitumori.readonly },
                      on: { change: _vm.selMCodeEXChange },
                      model: {
                        value: _vm.nouhin.id,
                        callback: function ($$v) {
                          _vm.$set(_vm.nouhin, "id", $$v)
                        },
                        expression: "nouhin.id",
                      },
                    },
                    _vm._l(_vm.sel_m_code_ex, function (option) {
                      return _c(
                        "option",
                        { key: option.id, domProps: { value: option.value } },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(option.text) +
                              "\n            "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v("\n            \n          "),
                  _c("label", {}, [_vm._v("納品日")]),
                  _vm._v(" "),
                  _c("v-date-picker", {
                    staticClass: "date_picker",
                    attrs: {
                      "model-config": { type: "string", mask: "YYYY-MM-DD" },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function ({ inputValue, inputEvents }) {
                          return [
                            _c(
                              "b-input",
                              _vm._g(
                                { attrs: { value: inputValue, readonly: "" } },
                                inputEvents
                              )
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                staticClass: "icon_btn_del",
                                attrs: { variant: "danger" },
                                on: { click: _vm.nouhinOnDel },
                              },
                              [
                                _c("b-icon", {
                                  attrs: { icon: "x", "aria-hidden": "true" },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.nouhin.nouhin_on,
                      callback: function ($$v) {
                        _vm.$set(_vm.nouhin, "nouhin_on", $$v)
                      },
                      expression: "nouhin.nouhin_on",
                    },
                  }),
                  _vm._v("\n            \n          "),
                  _c("label", {}, [_vm._v("請求日")]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "160px" },
                    attrs: { type: "text", disabled: "" },
                    model: {
                      value: _vm.nouhin.seikyu_on_fmt,
                      callback: function ($$v) {
                        _vm.$set(_vm.nouhin, "seikyu_on_fmt", $$v)
                      },
                      expression: "nouhin.seikyu_on_fmt",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-inline",
                  staticStyle: { margin: "10px 0px" },
                },
                [
                  _c("label", [_vm._v("品題")]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "200px" },
                    attrs: { type: "text", readonly: _vm.mitumori.readonly },
                    model: {
                      value: _vm.mitumori.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.mitumori, "title", $$v)
                      },
                      expression: "mitumori.title",
                    },
                  }),
                  _vm._v("\n            \n          "),
                  _c("label", [_vm._v("品類")]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "200px" },
                    attrs: { type: "text", readonly: _vm.mitumori.readonly },
                    model: {
                      value: _vm.mitumori.teiki_type1,
                      callback: function ($$v) {
                        _vm.$set(_vm.mitumori, "teiki_type1", $$v)
                      },
                      expression: "mitumori.teiki_type1",
                    },
                  }),
                  _vm._v("\n            \n          "),
                  _c("label", [_vm._v("品目")]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "200px" },
                    attrs: { type: "text", readonly: _vm.mitumori.readonly },
                    model: {
                      value: _vm.mitumori.teiki_type2,
                      callback: function ($$v) {
                        _vm.$set(_vm.mitumori, "teiki_type2", $$v)
                      },
                      expression: "mitumori.teiki_type2",
                    },
                  }),
                  _vm._v("\n            \n        "),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-inline",
                  staticStyle: { margin: "10px 0px" },
                },
                [
                  _c("SelectClientCompany", {
                    on: { on_select: _vm.onClientCompanySelect },
                  }),
                  _vm._v(" "),
                  _c("label", [_vm._v("顧客")]),
                  _vm._v(" "),
                  _vm.mitumori.readonly
                    ? _c(
                        "span",
                        [
                          _c("b-input", {
                            staticStyle: { width: "200px" },
                            attrs: { type: "text", readonly: "" },
                            model: {
                              value: _vm.mitumori.client_company_name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.mitumori,
                                  "client_company_name",
                                  $$v
                                )
                              },
                              expression: "mitumori.client_company_name",
                            },
                          }),
                          _vm._v(" "),
                          !_vm.client_loading
                            ? _c(
                                "b-button",
                                {
                                  staticClass: "icon_btn",
                                  attrs: { variant: "info" },
                                },
                                [
                                  _c("b-icon", {
                                    attrs: {
                                      icon: "search",
                                      "aria-hidden": "true",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _c(
                        "span",
                        [
                          _c("b-input", {
                            staticStyle: {
                              width: "200px",
                              "background-color": "white",
                            },
                            attrs: { type: "text", readonly: "" },
                            on: { click: _vm.selectClientCompanyModalShow },
                            model: {
                              value: _vm.mitumori.client_company_name,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.mitumori,
                                  "client_company_name",
                                  $$v
                                )
                              },
                              expression: "mitumori.client_company_name",
                            },
                          }),
                          _vm._v(" "),
                          !_vm.client_loading
                            ? _c(
                                "b-button",
                                {
                                  staticClass: "icon_btn",
                                  attrs: { variant: "info" },
                                  on: {
                                    click: _vm.selectClientCompanyModalShow,
                                  },
                                },
                                [
                                  _c("b-icon", {
                                    attrs: {
                                      icon: "search",
                                      "aria-hidden": "true",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.client_loading
                            ? _c(
                                "b-button",
                                {
                                  staticClass: "icon_btn",
                                  attrs: { variant: "info", disabled: "" },
                                },
                                [
                                  _c("span", {
                                    staticClass:
                                      "spinner-border spinner-border-sm",
                                    attrs: {
                                      role: "status",
                                      "aria-hidden": "true",
                                    },
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                  _vm._v("\n            \n          "),
                  _c("label", [_vm._v("敬称")]),
                  _vm._v(" "),
                  _c(
                    "b-form-select",
                    {
                      staticStyle: { width: "70px" },
                      model: {
                        value: _vm.nouhin.keisyou,
                        callback: function ($$v) {
                          _vm.$set(_vm.nouhin, "keisyou", $$v)
                        },
                        expression: "nouhin.keisyou",
                      },
                    },
                    _vm._l(_vm.sel_keisyou, function (option) {
                      return _c(
                        "option",
                        { key: option.id, domProps: { value: option.value } },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(option.text) +
                              "\n            "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v("\n            \n          "),
                  _c("label", [_vm._v("顧客担当者")]),
                  _vm._v(" "),
                  _c(
                    "b-form-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: { disabled: _vm.mitumori.readonly },
                      model: {
                        value: _vm.mitumori.client_person_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.mitumori, "client_person_id", $$v)
                        },
                        expression: "mitumori.client_person_id",
                      },
                    },
                    [
                      _c("option"),
                      _vm._v(" "),
                      _vm._l(_vm.sel_client_person, function (option) {
                        return _c(
                          "option",
                          { key: option.id, domProps: { value: option.value } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(option.text) +
                                "\n            "
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                  _vm._v("\n            \n          "),
                  _c("label", [_vm._v("担当者")]),
                  _vm._v(" "),
                  _c(
                    "b-form-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: { disabled: _vm.mitumori.readonly },
                      model: {
                        value: _vm.nouhin.user_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.nouhin, "user_id", $$v)
                        },
                        expression: "nouhin.user_id",
                      },
                    },
                    _vm._l(_vm.sel_person, function (option) {
                      return _c(
                        "option",
                        { key: option.id, domProps: { value: option.value } },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(option.text) +
                              "\n            "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-inline",
                  staticStyle: { margin: "10px 0px" },
                },
                [
                  _c("label", [_vm._v("備考")]),
                  _vm._v(" "),
                  _c("b-form-textarea", {
                    staticStyle: { width: "300px" },
                    attrs: { id: "textarea", rows: "2", "max-rows": "2" },
                    model: {
                      value: _vm.nouhin.note,
                      callback: function ($$v) {
                        _vm.$set(_vm.nouhin, "note", $$v)
                      },
                      expression: "nouhin.note",
                    },
                  }),
                  _vm._v("\n           \n          "),
                  _c(
                    "b-button",
                    {
                      staticStyle: { "margin-left": "510px" },
                      attrs: {
                        type: "submit",
                        variant: "primary",
                        disabled: _vm.mitumori.cancel,
                      },
                    },
                    [
                      _c("b-icon", { attrs: { icon: "save" } }),
                      _vm._v(" 保存\n          "),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._v("\n              \n          "),
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: {
                        id: "checkbox-1",
                        name: "checkbox-1",
                        disabled:
                          _vm.nouhin.seikyu_status || _vm.mitumori.cancel,
                      },
                      on: { change: _vm.nouhin_submit },
                      model: {
                        value: _vm.nouhin.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.nouhin, "status", $$v)
                        },
                        expression: "nouhin.status",
                      },
                    },
                    [_vm._v("\n            納品済み\n          ")]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v("\n      商品\n      "),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              { staticStyle: { width: "1090px" } },
              [
                _c("b-table-filter", {
                  attrs: {
                    maxHeight: _vm.maxHeight,
                    filter_list: _vm.filter_list,
                    filter_val: _vm.filter_val,
                    data_list_field: _vm.data_list_field,
                    data_list: _vm.data_list,
                    filter_enable: false,
                    edit_disabled: _vm.nouhin.status,
                  },
                  on: { on_edit: _vm.modalShow },
                }),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "form-inline",
              staticStyle: { width: "1090px", margin: "-15px 0px 0px 0px" },
            },
            [
              _c("span", { staticStyle: { width: "100px" } }, [
                _vm._v(_vm._s(_vm.data_list.length) + "件"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ml-auto d-flex align-items-center" },
                [
                  _vm._l(_vm.total_by_tax, function (sum) {
                    return _c(
                      "span",
                      {
                        key: sum.key,
                        staticClass: "form-inline",
                        staticStyle: { "margin-left": "" },
                      },
                      [
                        _vm._v("\n                \n          "),
                        _c("label", [_vm._v(_vm._s(sum.key) + "%対象")]),
                        _vm._v(" "),
                        _c("b-input", {
                          staticStyle: {
                            width: "200px",
                            "text-align": "right",
                          },
                          attrs: {
                            value: sum.total + " (税 " + sum.tax + ")",
                            type: "text",
                            readonly: "",
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  _vm._v("\n              \n        "),
                  _c("label", [_vm._v("合計")]),
                  _vm._v(" "),
                  _c("b-input", {
                    staticStyle: { width: "200px", "text-align": "right" },
                    attrs: {
                      value: _vm.sum_total + " (税 " + _vm.sum_tax + ")",
                      type: "text",
                      readonly: "",
                    },
                  }),
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              attrs: {
                id: "modal-mitumori",
                title: "商品",
                "header-bg-variant": "dark",
                "header-text-variant": "light",
                "body-bg-variant": "light",
                "hide-footer": "",
                centered: "",
              },
            },
            [
              _c("div", { staticClass: "modal_div" }, [
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("伝票番号")]),
                    _vm._v(" "),
                    _c(
                      "b-form-select",
                      {
                        staticStyle: { width: "200px" },
                        model: {
                          value: _vm.mitumori_detail.nouhin_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.mitumori_detail, "nouhin_id", $$v)
                          },
                          expression: "mitumori_detail.nouhin_id",
                        },
                      },
                      [
                        _c("option", { attrs: { value: "-1" } }, [
                          _vm._v(
                            "\n                " +
                              _vm._s("新規") +
                              "\n              "
                          ),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.sel_m_code_ex, function (option) {
                          return _c(
                            "option",
                            {
                              key: option.id,
                              domProps: { value: option.value },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(option.text) +
                                  "\n              "
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("商品分類")]),
                    _vm._v(" "),
                    _c(
                      "b-form-select",
                      {
                        staticStyle: { width: "200px" },
                        attrs: { disabled: true },
                        on: { change: _vm.selItemTypeChange },
                        model: {
                          value: _vm.mitumori_detail.item_type_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.mitumori_detail, "item_type_id", $$v)
                          },
                          expression: "mitumori_detail.item_type_id",
                        },
                      },
                      _vm._l(_vm.sel_item_type, function (option) {
                        return _c(
                          "option",
                          { key: option.id, domProps: { value: option.value } },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(option.text) +
                                "\n              "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("商品名")]),
                    _vm._v(" "),
                    _c(
                      "b-form-select",
                      {
                        staticStyle: { width: "200px" },
                        attrs: { disabled: true },
                        on: { change: _vm.selItemChange },
                        model: {
                          value: _vm.mitumori_detail.item_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.mitumori_detail, "item_id", $$v)
                          },
                          expression: "mitumori_detail.item_id",
                        },
                      },
                      _vm._l(_vm.sel_item, function (option) {
                        return _c(
                          "option",
                          { key: option.id, domProps: { value: option.value } },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(option.text) +
                                "\n              "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("単価")]),
                    _vm._v(" "),
                    _c("b-input", {
                      attrs: { type: "number", readonly: "" },
                      model: {
                        value: _vm.mitumori_detail.tanka,
                        callback: function ($$v) {
                          _vm.$set(_vm.mitumori_detail, "tanka", $$v)
                        },
                        expression: "mitumori_detail.tanka",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("数量")]),
                    _vm._v(" "),
                    _c("b-input", {
                      attrs: { type: "number", readonly: "" },
                      model: {
                        value: _vm.mitumori_detail.quantity,
                        callback: function ($$v) {
                          _vm.$set(_vm.mitumori_detail, "quantity", $$v)
                        },
                        expression: "mitumori_detail.quantity",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c("label", [_vm._v("税率")]),
                    _vm._v(" "),
                    _c("b-input", {
                      attrs: { type: "text", readonly: "" },
                      model: {
                        value: _vm.mitumori_detail.tax,
                        callback: function ($$v) {
                          _vm.$set(_vm.mitumori_detail, "tax", $$v)
                        },
                        expression: "mitumori_detail.tax",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-footer" },
                  [
                    _c(
                      "b-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.$bvModal.hide("modal-mitumori")
                          },
                        },
                      },
                      [
                        _c("b-icon", { attrs: { icon: "x" } }),
                        _vm._v("取消\n            "),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "primary" },
                        on: { click: _vm.updateNouhinDetail },
                      },
                      [
                        _c("b-icon", { attrs: { icon: "save" } }),
                        _vm._v(" 保存\n            "),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }